import { definePage } from '@reflex/plugin-api/web';
import type { PluginWebManifest } from '@reflex/plugin-api/web';

const page = definePage({
  path: '/configure/connect/tailscale',
  label: 'Tailscale',
  icon: 'Tailscale',
  group: 'security',
  componentPath: '@reflex/plugin-tailscale/web/TailscalePage',
  description: 'Put agent devboxes on your tailnet.',
  details:
    'Store reusable Tailscale auth-key profiles per org and attach them to agent runs. Devboxes join your tailnet at startup, so agents can reach private services (databases, internal APIs, staging hosts) by their Tailscale names without exposing them to the public internet.',
  features: [
    'Reusable auth-key profiles managed per organization',
    'Attach a profile to an agent run from the new-agent picker',
    'Devboxes join the tailnet automatically at startup',
    'Tailscale section on every agent detail page',
    'Profile resource preview for cross-plugin references',
  ],
});

export const tailscaleWeb: PluginWebManifest = {
  ...page.web,
  // The standalone /tailscale route stays as the daily-use surface
  // (browse + manage profiles). The same component also drives
  // setup in the wizard slide-over and the plugin detail page.
  orgSetupComponent: {
    componentPath: '@reflex/plugin-tailscale/web/TailscalePage',
    label: 'Create a Tailscale profile with an auth key so devboxes can join your tailnet.',
  },
  attachments: [
    {
      id: 'tailscale-profile',
      label: 'Tailscale Profile',
      icon: 'Tailscale',
      order: 30,
      pickerComponentPath: '@reflex/plugin-tailscale/web/TailscaleProfilePicker',
      summaryComponentPath: '@reflex/plugin-tailscale/web/TailscaleProfileSummary',
    },
  ],
  launchMentionProviders: [
    {
      id: 'launch-mention-tailscale',
      label: 'Tailscale Profiles',
      keyword: 'tailscale',
      icon: 'Tailscale',
      componentPath: '@reflex/plugin-tailscale/web/TailscaleMentionProvider',
      createComponentPath: '@reflex/plugin-tailscale/web/TailscaleMentionCreate',
      createLabel: 'Add Tailscale profile',
      order: 40,
    },
  ],
  agentDetailSections: [
    {
      id: 'tailscale-profile',
      label: 'Tailscale',
      icon: 'Tailscale',
      componentPath: '@reflex/plugin-tailscale/web/TailscaleDetailSection',
      order: 15,
    },
  ],
  resourcePreviews: [
    {
      kind: 'tailscale',
      label: 'Tailscale Profile',
      icon: 'Tailscale',
      componentPath: '@reflex/plugin-tailscale/web/TailscalePreview',
      detailHref: '/configure/connect/tailscale',
      // The profile prefix (`shared/ids.ts`), so a bare `tsp_…` id anywhere
      // in the app resolves this preview's icon and hover card.
      idPrefixes: ['tsp'],
    },
  ],
  marketingPreviews: [
    {
      id: 'tailscale-profile-card',
      label: 'Tailscale profiles card',
      description:
        'Sample Tailscale auth-key profiles with tags and exit nodes. Preview of the profile management UI.',
      surface: 'card',
      componentPath: '@reflex/plugin-tailscale/web/TailscaleProfileCardPreview',
    },
  ],
};
